export const areas = [
	"Auvergne Rhône-Alpes",
	"Bourgogne-Franche-Comté",
	"Bretagne",
	"Centre - Val de Loire",
	"Corse",
	"Grand-Est",
	"Hauts-de-France",
	"Ile-de-France",
	"Normandie",
	"Nouvelle-Aquitaine",
	"Occitanie",
	"Provence-Alpes-Côte d’Azur",
	"Pays de La Loire",
	"Guadeloupe",
	"Guyane",
	"La Réunion",
	"Martinique",
	"Mayotte"
];
